import { Link } from 'react-router-dom';

export default function FinalCTASection() {
  return (
    <section className="relative py-20 md:py-28 px-6 md:px-10 bg-background-50 overflow-hidden">
      <div className="absolute bottom-0 left-0 right-0 overflow-hidden">
        <div className="flex gap-4 animate-[scrollRight_40s_linear_infinite]">
          {ctaImages.map((img, i) => (
            <div key={i} className="flex-shrink-0 w-[240px] h-[160px] md:w-[300px] md:h-[200px] rounded-2xl overflow-hidden bg-background-100 opacity-70">
              <img
                src={img}
                alt=""
                className="w-full h-full object-cover object-top"
                loading="lazy"
              />
            </div>
          ))}
          {ctaImages.map((img, i) => (
            <div key={`dup-${i}`} className="flex-shrink-0 w-[240px] h-[160px] md:w-[300px] md:h-[200px] rounded-2xl overflow-hidden bg-background-100 opacity-70">
              <img
                src={img}
                alt=""
                className="w-full h-full object-cover object-top"
                loading="lazy"
              />
            </div>
          ))}
        </div>
      </div>

      <div className="relative z-10 max-w-[700px] mx-auto text-center pb-[220px] md:pb-[260px]">
        <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-950 mb-4">
          Start Using OOPBuy Spreadsheet Guide Today
        </h2>
        <p className="text-base text-foreground-600 leading-relaxed mb-8 max-w-[560px] mx-auto">
          Get full access to structured guides, comparisons, and tutorials designed to help you understand the system clearly and make better decisions.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/oopbuy-spreadsheet-guide"
            onClick={() => window.scrollTo(0, 0)}
            className="inline-flex items-center gap-2 px-7 py-3.5 bg-primary-500 text-background-50 font-semibold rounded-full hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer text-sm"
          >
            Explore Full Guide
            <i className="ri-arrow-right-line text-base"></i>
          </Link>
          <a
            href="https://kaspreadsheet.com/"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-2 px-7 py-3.5 border-2 border-primary-500 text-primary-600 font-semibold rounded-full hover:bg-primary-50 transition-colors whitespace-nowrap cursor-pointer text-sm"
          >
            Go to Official Platform
            <i className="ri-arrow-right-up-line text-base"></i>
          </a>
        </div>
      </div>

      <style>{`
        @keyframes scrollRight {
          0% { transform: translateX(-50%); }
          100% { transform: translateX(0); }
        }
      `}</style>
    </section>
  );
}

const ctaImages = [
  'https://readdy.ai/api/search-image?query=Colorful%20artisan%20market%20stall%20with%20handmade%20textile%20goods%20hanging%20in%20warm%20afternoon%20sunlight%2C%20vibrant%20Mexican%20marketplace%20aesthetic%2C%20rich%20terracotta%20and%20turquoise%20accents%2C%20travel%20lifestyle%20photography%2C%20textured%20woven%20fabrics%20and%20handcrafted%20ceramics%20visible&width=600&height=400&seq=cta-deco-v2-01&orientation=landscape',
  'https://readdy.ai/api/search-image?query=Modern%20boutique%20clothing%20rack%20with%20curated%20designer%20pieces%20in%20earthy%20tones%2C%20warm%20gallery%20lighting%2C%20minimalist%20retail%20interior%20with%20concrete%20floors%20and%20brass%20fixtures%2C%20upscale%20shopping%20experience%20aesthetic%2C%20editorial%20fashion%20retail%20photography&width=600&height=400&seq=cta-deco-v2-02&orientation=landscape',
  'https://readdy.ai/api/search-image?query=Vintage%20leather%20goods%20workshop%20with%20tools%20and%20finished%20bags%20displayed%20on%20a%20rustic%20oak%20workbench%2C%20warm%20industrial%20pendant%20lighting%2C%20artisan%20craftsmanship%20aesthetic%2C%20cognac%20and%20chestnut%20tones%2C%20handmade%20quality%20photography%20with%20visible%20stitching%20details&width=600&height=400&seq=cta-deco-v2-03&orientation=landscape',
  'https://readdy.ai/api/search-image?query=Sunlit%20Mediterranean%20terrace%20with%20a%20bistro%20table%20displaying%20fashion%20accessories%20and%20an%20espresso%20cup%2C%20whitewashed%20walls%20with%20bougainvillea%20flowers%2C%20European%20summer%20lifestyle%20photography%2C%20soft%20coral%20and%20sandstone%20tones%2C%20relaxed%20vacation%20shopping%20mood&width=600&height=400&seq=cta-deco-v2-04&orientation=landscape',
  'https://readdy.ai/api/search-image?query=Modern%20concept%20store%20interior%20with%20geometric%20shelving%20displaying%20curated%20lifestyle%20products%2C%20warm%20ambient%20track%20lighting%2C%20Scandinavian%20Japanese%20fusion%20aesthetic%2C%20muted%20sage%20and%20ash%20tones%2C%20clean%20architectural%20lines%2C%20premium%20retail%20design%20photography&width=600&height=400&seq=cta-deco-v2-05&orientation=landscape',
];